import React from "react";
import { VerticalSeparator } from "../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import { ExistingAgentGroupForm } from "../../types";
import settingsStyles from "../../../../../styles/settings.css";
import classNames from "classnames";
import cStyles from "../styles.css";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { AdvisersAvatarList } from "../advisersAvatarList/advisersAvatarList";
import { useStore } from "../../../../../models";
import { TagsList } from "../../../tags/tagName/tagsList";
import styles from "./existingAgentGroupBox.css";

interface Props {
  form: ExistingAgentGroupForm;
}

export const ExistingAgentGroupBox = ({ form }: Props) => {
  const { agentStore, tagsStore, tagGroupsStore } = useStore();
  const advisers = agentStore.getByIds(form.$.adviserIds.$);
  const tags = tagsStore.getFromIds(form.$.tagIds.$);
  const tagGroups = tagGroupsStore.getFromIds(form.$.tagGroupIds.$);

  return (
    <div className={cStyles.form}>
      <div className={classNames(settingsStyles["flex-column"], styles.column)}>
        <span className={classNames(settingsStyles["form-label-font"], cStyles["label-margin"])}>
          {intl.formatMessage("settings.adviserGroups.form.group")}
        </span>
        <span className={settingsStyles["form-content-font"]}>{form.$.name.$}</span>
      </div>
      <VerticalSeparator />
      <div className={classNames(settingsStyles["flex-column"], styles.column)}>
        <span className={classNames(settingsStyles["form-label-font"], cStyles["label-margin"])}>
          {intl.formatMessage("settings.adviserGroups.form.advisers")}
        </span>
        <AdvisersAvatarList advisers={advisers} />
      </div>
      <VerticalSeparator />
      <div className={classNames(settingsStyles["flex-column"], styles.column)}>
        <span className={classNames(settingsStyles["form-label-font"], cStyles["label-margin"])}>
          {intl.formatMessage("settings.adviserGroups.form.skills")}
        </span>
        {!!tagGroups.length || !!tags.length ? (
          <TagsList tagGroups={tagGroups} tags={tags} />
        ) : (
          <span className={settingsStyles["form-description-font"]}>
            {intl.formatMessage("settings.adviserGroups.form.skills.placeholder")}
          </span>
        )}
      </div>
    </div>
  );
};
